import React from 'react';
import './Loading.css';

const Loading = ({
  message = 'Carregando...',
  size = 'medium',
  fullScreen = false
}) => {
  const sizeClass = `loading-${size}`;
  const containerClass = fullScreen ? 'loading-fullscreen' : 'loading-container';

  return (
    <div className={containerClass}>
      <div className={`loading-spinner ${sizeClass}`}>
        <div className="logo-container">
          <img
            src="/assets/logo_256x256.png"
            alt="Aliado Logo"
            className="loading-logo"
          />
        </div>
      </div>
    </div>
  );
};

export default Loading;